import React from 'react';
import { Chip } from '@mui/material';
import { VERDICT_COLORS } from './verdictColors';

export const VerdictChip: React.FC<{ verdict: string }> = ({ verdict }) => (
  <Chip
    label={verdict.toUpperCase()}
    size="small"
    sx={{
      backgroundColor: VERDICT_COLORS[verdict] || VERDICT_COLORS.na,
      color: '#fff',
      fontWeight: 600,
      fontSize: '0.7rem',
      height: 20,
    }}
  />
);
